export default{
  TOKEN: state => state.TOKEN,
  REFRESH_TOKEN: state => state.REFRESH_TOKEN,
  ACCESS_TOKEN: state => state.ACCESS_TOKEN,
  INFO: state => state.INFO
}


// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js